// ─── What a calendar event is · from the Academy (sprint 13, stage 4) ───────
//
// Two or three lines for each kind of event, taken from the lesson that
// explains it, with that lesson's source and a "קרא עוד" into it. The lines
// say what the event IS. They say nothing about what it will show or what it
// will do to anything: a release date is a date.
//
// Every sentence here rests on the source named beside it, as quoted in the
// lesson (academy/track-2.md, track-4.md). When a lesson changes, this file
// changes with it.
import { FOMC_SOURCE } from "./fomc";

export const MACRO_CONTEXT = {
  cpi: {
    lines: [
      "לפי ה-BLS, מדד המחירים לצרכן מודד את השינוי הממוצע לאורך זמן במחירים שמשלמים צרכנים עירוניים על סל של מוצרים ושירותים.",
      "המדד מתפרסם כל חודש. פרסום באוקטובר, למשל, מתאר את ספטמבר.",
    ],
    lesson: "4.2",
    sources: [{ text: "BLS · Consumer Price Index", url: "https://www.bls.gov/cpi/" }],
  },
  pce: {
    lines: [
      "לפי ה-BEA, מדד ה-PCE מודד את המחירים שאנשים בארה\"ב משלמים על מוצרים ושירותים. הוא מתפרסם כל חודש, בדוח Personal Income and Outlays.",
      "לפי הפד, יעד האינפלציה של 2% נמדד לפי השינוי השנתי במדד הזה.",
    ],
    lesson: "4.2",
    sources: [
      { text: "BEA · Personal Consumption Expenditures Price Index", url: "https://www.bea.gov/data/personal-consumption-expenditures-price-index" },
      { text: "Federal Reserve · יעד 2% לפי מדד PCE", url: "https://www.federalreserve.gov/faqs/what-economic-goals-does-federal-reserve-seek-to-achieve-through-monetary-policy.htm" },
    ],
  },
  jobs: {
    lines: [
      "דוח התעסוקה של ה-BLS מתפרסם כל חודש. מספר המשרות מגיע מסקר עסקים (CES), ושיעור האבטלה מסקר של כ-60,000 משקי בית.",
      "לפי ה-BLS, בכל פרסום מתוקנים האומדנים של שני החודשים הקודמים.",
    ],
    lesson: "4.3",
    sources: [{ text: "BLS · The Employment Situation, Technical Note", url: "https://www.bls.gov/news.release/empsit.tn.htm" }],
  },
  gdp: {
    lines: [
      "לפי ה-BEA, התוצר מודד את ערך המוצרים והשירותים הסופיים שיוצרו בארה\"ב.",
      "הוא מתפרסם כל רבעון, בשלושה אומדנים לכל רבעון, ומוצג בשיעור שנתי.",
    ],
    lesson: "4.3",
    sources: [{ text: "BEA · What to Know About GDP", url: "https://www.bea.gov/resources/learning-center/what-to-know-gdp" }],
  },
  fomc: {
    lines: [
      "ישיבה קבועה לפי לוח הפד. בישיבה, ועדת ה-FOMC קובעת את טווח היעד לריבית הפדרל פאנדס.",
      "לפי הפד, כל מועד טנטטיבי עד שהוא מאושר בישיבה שלפניו.",
    ],
    lesson: "4.1",
    sources: [{ text: FOMC_SOURCE.name, url: FOMC_SOURCE.url, checked: FOMC_SOURCE.checked }],
  },
};

export const EARNINGS_CONTEXT = {
  lines: ["המועד כאן הוא מועד ההודעה על התוצאות. הדוח המלא מוגש ל-SEC בטופס 10-Q (רבעוני) או 10-K (שנתי) ומתפרסם ב-EDGAR, לא בהכרח באותו יום."],
  lesson: "2.1",
  sources: [{ text: "SEC · EDGAR, חיפוש הגשות", url: "https://www.sec.gov/edgar/search/" }],
};

export const HOLIDAY_CONTEXT = {
  closed: "השוק האמריקאי סגור",
  half: "השוק האמריקאי פתוח לפי לוח מקוצר",
  sources: [{ text: "NYSE · Holidays & Trading Hours", url: "https://www.nyse.com/markets/hours-calendars" }],
};
